<mat-spinner *ngIf="!init" color="primary" diameter="48"></mat-spinner>
<div *ngIf="init" class="container edit-project old-immo-mat-stepper">
  <mat-horizontal-stepper
    #projectStepper
    class="restyle-stepper-icons"
    [linear]="true"
  >
    <ng-template matStepperIcon="edit" let-index="index">
      {{ index + 1 }}
    </ng-template>

    <ng-template matStepperIcon="done" let-index="index">
      {{ index + 1 }}
    </ng-template>

    <mat-step [stepControl]="contactStepControl">
      <ng-template matStepLabel>Bedrijf</ng-template>
      <contact-picker
        [inputProject]="project"
        [fromOldSystem]="true"
        (projectContactChange)="setContacts($event)"
        (next)="finishContactStep()"
      ></contact-picker>
    </mat-step>

    <mat-step [stepControl]="configurationStepControl">
      <ng-template matStepLabel>Configuratie</ng-template>
      <ng-container *ngIf="contactStepFinished">
        <client-product-wrapper
          [inputProject]="project"
          [inputProduct]="project.products[0]"
          [oldSystemImmo]="true"
        ></client-product-wrapper>
      </ng-container>

      <div class="text-right">
        <button
          class="button"
          (click)="finishConfigurationStep()"
          type="button"
          mat-button
        >
          Volgende
        </button>
      </div>
    </mat-step>

    <mat-step [stepControl]="designStepControl">
      <ng-template matStepLabel>Ontwerp</ng-template>
      <ip-board-design-picker
        [project]="project"
        [ipBoard]="project.products[0]"
        [oldSystemImmo]="true"
      ></ip-board-design-picker>

      <div class="text-right">
        <button
          class="button"
          (click)="finishDesignStep()"
          type="button"
          mat-button
        >
          Volgende
        </button>
      </div>
    </mat-step>

    <mat-step [stepControl]="placementStepControl">
      <ng-template matStepLabel>Plaatsing</ng-template>
      <placement-picker
        [inputProject]="project"
        [inputSubProject]="baseProject"
        [inputProjectPlacement]="baseProject.projectPlacement"
        [fromOldSystem]="true"
      ></placement-picker>

      <div class="text-right">
        <button
          class="button"
          (click)="finishPlacementStep()"
          type="button"
          mat-button
        >
          Volgende
        </button>
      </div>
    </mat-step>

    <mat-step>
      <ng-template matStepLabel>Overzicht</ng-template>
      <client-base-project-summary
        [project]="project"
        [baseProject]="baseProject"
        [fromOldSystem]="true"
        [submitProjectResult]="submitProjectResult"
        (submitProject)="submitProject()"
      ></client-base-project-summary>
    </mat-step>
  </mat-horizontal-stepper>
</div>
